import React from 'react';

import { classnames } from '@/utils/classnames.ts';

const DescriptionListRoot = ({ className, ...props }: React.ComponentPropsWithRef<'dl'>) => (
    <dl {...props} className={classnames('divide-y divide-border', className)} />
);

export interface DescriptionListItemProps extends React.ComponentPropsWithRef<'div'> {
    label: React.ReactNode;
}

// Without a value, e.g. a client without an address, it says so with a dash rather than leaving the row out, so every
// detail there is to fill in stays in its place.
const DescriptionListItem = ({ label, className, children, ...props }: DescriptionListItemProps) => (
    <div
        {...props}
        className={classnames('grid grid-cols-1 gap-1 py-3.5 sm:grid-cols-[14rem_1fr] sm:gap-4', className)}
    >
        <dt className="text-text-muted">{label}</dt>
        <dd className="min-w-0 break-words">
            {children === null || children === undefined || children === '' || children === false ? (
                <span className="text-text-subtle">–</span>
            ) : (
                children
            )}
        </dd>
    </div>
);

export default Object.assign(DescriptionListRoot, {
    Item: DescriptionListItem,
});
